module.exports = __webpack_public_path__ + "6e1076e33ba8f4c457f3b71bfc8ee9a3.jpg";